/**
 * Filters a team-members list down to valid test-case reviewer candidates:
 * every eligible active project member can be a reviewer EXCEPT users whose
 * sole project role is Developer, and a user can never assign themselves as
 * their own reviewer. Members without an assigned project role (common on the
 * org-scoped fallback path) are still eligible.
 *
 * Mirrors the role-label convention used by the case-assignment picker in
 * cycles/components/assign-dialog.tsx (comma-separated `roleName` from the
 * enriched teammemberslist payload).
 */
export function getReviewerCandidates(
  members: any[] | null | undefined,
  currentUserId: number | string | null | undefined,
): any[] {
  if (!Array.isArray(members)) return [];
  return members.filter((m: any) => {
    if (currentUserId != null && String(m.id) === String(currentUserId))
      return false;
    const roles = String(m.roleName ?? "")
      .split(",")
      .map((t: string) => t.trim().toLowerCase())
      .filter(Boolean);
    // Exclude members whose only project role is Developer; everyone else
    // (Test Manager, Test Lead, Tester, Project Manager, unassigned, …) is eligible.
    const isDeveloperOnly =
      roles.length > 0 && roles.every((r) => r === "developer");
    return !isDeveloperOnly;
  });
}
